var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 14H22.1641M22.1641 14L18.6641 17.5M22.1641 14L18.6641 10.5",
    stroke: "#1A1C1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1693 7V5.5C22.1693 4.39543 21.2738 3.5 20.1693 3.5H7.83594C6.73137 3.5 5.83594 4.39543 5.83594 5.5V22.5C5.83594 23.6046 6.73137 24.5 7.83594 24.5H20.1693C21.2738 24.5 22.1693 23.6046 22.1693 22.5V21",
    stroke: "#1A1C1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a670b89567a15060d0f33bdeff06c987.svg";
export { ForwardRef as ReactComponent };